import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AppProvider } from "hooks/useApp";
import { DataProvider } from "hooks/useData";
import { ContextProvider } from "utilities/ContextProvider";
import { AuthProvider } from "hooks/useAuth";
import { ScreenProvider } from "hooks/useScreen";
import ModalProvider from "hooks/ModalProvider";
import { CoordinatesProvider } from "hooks/useCoordinates";
import { TabProvider } from "hooks/useAssetsActiveTab";
import { MinifiedMenuItemsProvider } from "hooks/useMinifiedMenu";
import { UnityActionsProvider } from "hooks/unityActions";
import { FileUploadProvider } from "hooks/FilesUploadContext";
import { MeasurementsProvider } from "hooks/MeasurementsContext";
import { AiChatProvider } from "hooks/AiChatContext";
import { UnityProvider } from "hooks/UseUnity";
import { SceneProvider } from "hooks/useScene";

import { loadRuntimeConfig, getRuntimeConfig } from "config/runtimeConfig";
import { energyApi } from "utilities/Axios";
async function bootstrap() {
  try {
    // Load runtime config first
    await loadRuntimeConfig();
    const runtimeConfig = getRuntimeConfig();

    // Ensure axios uses correct API baseURL
    energyApi.defaults.baseURL = runtimeConfig.REACT_APP_TSDCD_API;
    const root = ReactDOM.createRoot(
      document.getElementById("root") as HTMLElement
    );

    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <AuthProvider>
            <AppProvider>
              <FileUploadProvider>
                <MeasurementsProvider>
                  <UnityProvider>
                    <SceneProvider>
                      <TabProvider>
                        <ModalProvider>
                          <UnityActionsProvider>
                            <MinifiedMenuItemsProvider>
                              <ScreenProvider>
                                <CoordinatesProvider>
                                  <DataProvider>
                                    <ContextProvider>
                                      <AiChatProvider>
                                        <App />
                                      </AiChatProvider>
                                    </ContextProvider>
                                  </DataProvider>
                                </CoordinatesProvider>
                              </ScreenProvider>
                            </MinifiedMenuItemsProvider>
                          </UnityActionsProvider>
                        </ModalProvider>
                      </TabProvider>
                    </SceneProvider>
                  </UnityProvider>
                </MeasurementsProvider>
              </FileUploadProvider>
            </AppProvider>
          </AuthProvider>
        </BrowserRouter>
      </React.StrictMode >
    );
  } catch (error) {
    console.error("❌ Failed to load runtime config", error);

    const root = ReactDOM.createRoot(
      document.getElementById("root") as HTMLElement
    );
    root.render(
      <div style={{ padding: 20, color: "red" }}>
        <h1>Failed to load configuration</h1>
        <p>Please try refreshing the page.</p>
      </div>
    );
  }
}

bootstrap();